import { useState, memo } from "react";
import { REPORT_SECTIONS } from "../ReportPages/reportSections";
import { FaChevronRight, FaChevronDown } from "react-icons/fa";

const Reportsummary = ({ activeSection, onSectionChange, segmentations = [] }) => {
  const reportsData = [
    { id: "1", name: "1. Market Overview", key: REPORT_SECTIONS.ABOUT },
    { id: "2", name: "2. Key Market", key: REPORT_SECTIONS.DYNAMICS },
    {
      id: "3",
      name: "3. Market Segmentation",
      key: REPORT_SECTIONS.SEGMENTATION,
      subItems: (segmentations || []).map((seg, idx) => ({
        id: `3-${idx}`,
        name: seg.title,
        key: `seg-${idx}`
      }))
    },
    { id: "4", name: "4. IP Overview", key: REPORT_SECTIONS.IP_OVERVIEW },
    { id: "5", name: "5. Recent Developments", key: REPORT_SECTIONS.DEVELOPMENTS },
    { id: "6", name: "6. Competitive Landscape", key: REPORT_SECTIONS.COMPETITIVE },
    { id: "7", name: "7. Market Report Scope", key: REPORT_SECTIONS.SCOPE },
    { id: "8", name: "8. Table of Contents", key: REPORT_SECTIONS.TOC },
    { id: "9", name: "9. Research Methodology", key: REPORT_SECTIONS.METHODOLOGY },
    { id: "10", name: "10. Frequently Asked Questions", key: REPORT_SECTIONS.FAQ }
  ];

  // State to track expanded parent items
  const [expanded, setExpanded] = useState({});

  const toggleExpand = (key) => {
    setExpanded(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const renderItem = (item) => {
    const hasSubItems = item.subItems && item.subItems.length > 0;
    const isExpanded = expanded[item.key];
    const isActive = activeSection === item.key;

    return (
      <div key={item.id} className="mb-0">
        <button
          className={`btn text-start d-flex justify-content-between align-items-center w-100 px-2 py-1 rounded-1 border-0 jump-menu-item ${isActive ? 'active' : ''}`}
          onClick={() => {
            if (hasSubItems) {
              toggleExpand(item.key);
            }
            onSectionChange(item.key);
          }}
        >
          <span>{item.name}</span>
          {hasSubItems ? (
            isExpanded ? <FaChevronDown size={10} /> : <FaChevronRight size={10} />
          ) : (
            isActive && <FaChevronRight size={12} />
          )}
        </button>

        {/* Render Subitems */}
        {hasSubItems && isExpanded && (
          <div className="ps-3 mt-1 d-flex flex-column gap-1">
            {item.subItems.map(sub => {
              const isSubActive = activeSection === sub.key;
              return (
                <button
                  key={sub.id}
                  className={`btn text-start d-flex justify-content-between align-items-center w-100 py-1 px-3 rounded-1 border-0 jump-menu-subitem ${isSubActive ? 'active' : ''}`}
                  onClick={() => onSectionChange(sub.key)}
                >
                  <span>{sub.name}</span>
                </button>
              )
            })}
          </div>
        )}
      </div>
    );
  };

  return (
    <aside className="categories-wrapper">
      {/* Card 1: Navigation Menu */}
      <div className="rounded-2 sidebar-nav-card">
        <div className="hero-gradient-bg p-2">
          <h5 className="fw-bold text-dark mb-0 px-2 sidebar-heading">Jump to Content</h5>
        </div>

        <div className="d-flex flex-column custom-scrollbar sidebar-scroll-area pb-1">
          {reportsData.map((item) => renderItem(item))}
        </div>
      </div>
    </aside>
  );
};

export default memo(Reportsummary);